import { ADMIN_API } from '../AdminAPI';
export function createDownloadLinkService(api) {
    return {
        getDownloadLinkSetting() {
            return api.fetch(ADMIN_API.GET_DOWNLOAD_LINK);
        },
        updateDownloadLinkSetting(data) {
            return api.fetch(ADMIN_API.POST_DOWNLOAD_LINK, { data });
        }
    };
}
//# sourceMappingURL=DowloadLinkService.js.map